
      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "ApproveMcpAuthorizationResponse": [
      "ApproveMcpAuthorizationSuccess",
      "ErrorResponse"
    ],
    "AssistantMessage": [
      "AssistantAgentMessage",
      "AssistantBarChartMessage",
      "AssistantDownloadLeadListMessage",
      "AssistantLeadLinkMessage",
      "AssistantLineChartMessage",
      "AssistantPieChartMessage",
      "AssistantSystemMessage",
      "AssistantUserMessage"
    ],
    "BasicAuthenticationResponse": [
      "BasicAuthenticationRequireOtpResponse",
      "BasicAuthenticationResetPasswordResponse",
      "BasicAuthenticationSuccessfulResponse",
      "ErrorResponse"
    ],
    "Broadcast": [
      "DataSourceSyncBroadcast",
      "DummyBroadcast",
      "UserSessionBroadcast"
    ],
    "ChangeEmailResponse": [
      "ChangeEmailSuccessfulResponse",
      "ErrorResponse"
    ],
    "ChangePasswordResponse": [
      "ChangePasswordSuccessfulResponse",
      "ErrorResponse"
    ],
    "ConfirmEmailResponse": [
      "ConfirmEmailSuccessfulResponse",
      "ErrorResponse"
    ],
    "CreateOrganizationResponse": [
      "CreateOrganizationSuccessfulResponse",
      "ErrorResponse"
    ],
    "DenyMcpAuthorizationResponse": [
      "DenyMcpAuthorizationSuccess",
      "ErrorResponse"
    ],
    "DeregisterMcpClientResponse": [
      "DeregisterMcpClientSuccess",
      "ErrorResponse"
    ],
    "EnableAuthenticatorResponse": [
      "EnableAuthenticatorSuccessfulResponse",
      "ErrorResponse"
    ],
    "HandleLeadStatusResponse": [
      "ErrorResponse",
      "HandleLeadStatusSuccessfulResponse"
    ],
    "Invitation": [
      "OrganizationInvitation",
      "UserInvitation"
    ],
    "InviteResponse": [
      "ErrorResponse",
      "InviteSuccessfulResponse"
    ],
    "Lead": [
      "HirePurchaseLead",
      "OperatingLeaseLead"
    ],
    "Member": [
      "OrganizationMembership",
      "User"
    ],
    "RegisterMcpClientResponse": [
      "ErrorResponse",
      "RegisterMcpClientSuccess"
    ],
    "RequestNewPasswordResponse": [
      "ErrorResponse",
      "RequestNewPasswordSuccessfulResponse"
    ],
    "ResetPasswordResponse": [
      "ErrorResponse",
      "ResetPasswordSuccessfulResponse"
    ],
    "RevokeMcpAuthorizationResponse": [
      "ErrorResponse",
      "RevokeMcpAuthorizationSuccess"
    ],
    "SSOConfiguration": [
      "MSALConfiguration",
      "OIDCConfiguration"
    ],
    "SendWhatsappOtpResponse": [
      "ErrorResponse",
      "SendWhatsappOtpSuccessfulResponse"
    ],
    "UpdateBedrockModelConfigResponse": [
      "ErrorResponse",
      "UpdateBedrockModelConfigSuccessfulResponse"
    ],
    "UpdateEligibilityRuleResponse": [
      "ErrorResponse",
      "UpdateEligibilityRuleSuccessfulResponse"
    ],
    "UpdateLeadResponse": [
      "ErrorResponse",
      "UpdateLeadSuccessfulResponse"
    ],
    "UpdateMcpSettingsResponse": [
      "ErrorResponse",
      "UpdateMcpSettingsSuccessfulResponse"
    ],
    "UpdateOrganizationBaseInfoResponse": [
      "ErrorResponse",
      "UpdateOrganizationBaseInfoSuccessfulResponse"
    ],
    "UpdateOrganizationSSOResponse": [
      "ErrorResponse",
      "UpdateOrganizationSSOSuccessfulResponse"
    ],
    "UpdateProfileResponse": [
      "ErrorResponse",
      "UpdateProfileSuccessfulResponse"
    ],
    "UpdateWhatsappSettingsResponse": [
      "ErrorResponse",
      "UpdateWhatsappSettingsSuccessfulResponse"
    ],
    "VerifyOtpResponse": [
      "ErrorResponse",
      "VerifyOtpSuccessfulResponse"
    ],
    "VerifyWhatsappOtpResponse": [
      "ErrorResponse",
      "VerifyWhatsappOtpSuccessfulResponse"
    ]
  }
};
      export default result;
    